var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboardDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 885"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 929",
    x: 6,
    y: 17,
    width: 8,
    height: 7,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 930",
    x: 14,
    y: 20,
    width: 8,
    height: 4,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 928",
    x: 12,
    y: 15,
    width: 4,
    height: 9,
    fill: "url(#paint0_linear_18520_158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 2",
    d: "M13.0489 5.92705C13.3483 5.00574 14.6517 5.00574 14.9511 5.92705L15.1226 6.45491C15.2564 6.86694 15.6404 7.1459 16.0736 7.1459H16.6287C17.5974 7.1459 18.0002 8.38551 17.2164 8.95492L16.7674 9.28115C16.4169 9.5358 16.2703 9.98716 16.4041 10.3992L16.5757 10.927C16.875 11.8484 15.8205 12.6145 15.0368 12.0451L14.5878 11.7188C14.2373 11.4642 13.7627 11.4642 13.4122 11.7188L12.9632 12.0451C12.1795 12.6145 11.125 11.8484 11.4243 10.9271L11.5959 10.3992C11.7297 9.98716 11.5831 9.5358 11.2326 9.28115L10.7836 8.95492C9.99985 8.38551 10.4026 7.1459 11.3713 7.1459H11.9264C12.3596 7.1459 12.7436 6.86694 12.8774 6.45491L13.0489 5.92705Z",
    fill: "url(#paint1_linear_18520_158)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18520_158",
    x1: 14,
    y1: 15,
    x2: 14,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18520_158",
    x1: 14,
    y1: 3,
    x2: 14,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardDark);
export default __webpack_public_path__ + "static/media/leaderboard_dark.9c0479930399e6e3cd548f64c847e39e.svg";
export { ForwardRef as ReactComponent };